import React from 'react';
import { THEMES } from '../data/constants';
import './ThemePlaylists.css';

export default function ThemePlaylists({ onSelectTheme, activeTheme }) {
  return (
    <div className="theme-playlists">
      <h3>🎭 主题播放列表</h3>
      <div className="theme-grid">
        {THEMES.map(theme => (
          <button
            key={theme.id}
            className={`theme-btn ${activeTheme === theme.id ? 'active' : ''}`}
            onClick={() => onSelectTheme(theme)}
          >
            <span className="theme-emoji">{theme.emoji}</span>
            <span className="theme-label">{theme.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
